'use client'

import { ReceiptForm } from '@/features/update-receipt-information'
import { ScrollProvider } from '@/shared/lib'

export const ReceiptForFee = () => {
  return (
    <ScrollProvider>
      <div className="mt-10 space-y-4">
        <h3 className="typo-body1 font-semibold text-black">
          수수료에 대한 영수증 발급
        </h3>
        <ReceiptForm scrollBlock="center" />
      </div>
    </ScrollProvider>
  )
}
